/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * MobiViz
 * The MobiViz API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */

export type VehicleTypesDtoVehicleTypesItem =
  (typeof VehicleTypesDtoVehicleTypesItem)[keyof typeof VehicleTypesDtoVehicleTypesItem];

export const VehicleTypesDtoVehicleTypesItem = {
  car: "car",
  motorcycle: "motorcycle",
  bus: "bus",
  truck: "truck",
  bike: "bike",
  pedestrian: "pedestrian",
} as const;
